jQuery(document).ready(function($){
  $("#mob-head-default-search").click(function(e){
    e.preventDefault();
    $(".search-overlay").toggleClass("open");
  });
  
  $(".close-overlay").click(function(e){
    e.preventDefault();
    $(".search-overlay").removeClass("open");
  });


  $("#desk-head-default-search").on("click", function(e) {
    e.preventDefault();
    e.stopPropagation();
    $(".desk-search .search").toggleClass("open");
    $(".desk-search").toggleClass("close-icon");
    if ($(".desk-search .search").hasClass("open")) {
      $(".desk-search .search input[name='q']").trigger("focus");
    }
  });
  $(document).on("click", function(e) {
    if ($(e.target).closest(".desk-search").length === 0) {
      $(".desk-search .search").removeClass("open");
      $(".desk-search").removeClass("close-icon");
    }
  });
  
});
